export default [
  {
    path: '/wait/number',
    component: () => import('Pages/wait/wait-number.vue')
  },
  {
    path: '/wait/more',
    component: () => import('Pages/wait/wait-more.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/wait.js